// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dc9k","footer":"styles_footer__3i_-d","passCodeTooltip":"styles_passCodeTooltip__19v09"};